import App from './App'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { AuthenticateParams } from 'configs/constants/enums'
import { suppressDefaultPropsWarnings } from './utils/suppressWarnings'

// Suppress defaultProps warnings from reactstrap components
suppressDefaultPropsWarnings()

// Cross-origin logout: each subdomain has its own localStorage. When the user logs out
// from <subdomain>.host, authStore.logout redirects here (app.host) with `?logout=1`
// so this origin's stored tokens are also cleared BEFORE the app bootstraps. Otherwise
// RootRedirect would see a stale token on app.host and re-route to /select-organization.
try {
  const params = new URLSearchParams(window.location.search)
  if (params.get('logout') === '1') {
    try {
      localStorage.clear()
    } catch {
      localStorage.removeItem(AuthenticateParams.ACCESS_TOKEN)
      localStorage.removeItem(AuthenticateParams.ORG_ID)
      localStorage.removeItem(AuthenticateParams.ACTIVE_PROFILE_ID)
      localStorage.removeItem(AuthenticateParams.ACTIVE_PROFILE_TYPE)
    }
    try {
      sessionStorage.clear()
    } catch {
      // ignore
    }
    params.delete('logout')
    const qs = params.toString()
    const cleanUrl = window.location.pathname + (qs ? `?${qs}` : '') + window.location.hash
    window.history.replaceState({}, '', cleanUrl)
  }
} catch {
  // Defensive — never block app boot on URL parsing failure.
}

const container = document.getElementById('root')
const root = createRoot(container!) // createRoot(container!) if you use TypeScript
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
)

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
